export default "__VITE_ASSET__BU8gIG0X__"